module.exports = __webpack_public_path__ + "static/2017-aeta-outreach3-4a19d7856d14fc95b77f4f4199889ab8.jpg";